import { Router } from "@frui.ts/screens";
import { Modules } from "config";
import type { interfaces } from "inversify";
import { computed } from "mobx";
import EnumRepository from "repositories/enumRepository";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import type Municipality from "entities/municipality";
import OptionsService from "services/optionsService";
import SecurityService from "services/securityService";
import Region from "entities/region";
import EditableDetailViewModel from "viewModels/editableDetailViewModel";

@Router.registerRoute({ name: Router.Self, route: ":municipalityId" })
export default class MunicipalityDetailViewModel extends EditableDetailViewModel<Municipality> {
  readonly modelName = "municipality";

  constructor(
    protected itemId: string,
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected notificationService: NotificationService,
    protected securityService: SecurityService,
    private optionsService: OptionsService
  ) {
    super(itemId);
  }

  protected loadDetail(): Promise<Municipality> | Municipality {
    return this.repository.get(this.itemId, "municipalities");
  }

  @computed
  get regionOptions() {
    return this.optionsService.entityOptions(Region);
  }

  updateData(): Promise<Municipality> {
    return this.repository.update(this.item, "municipalities");
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.timeCharges, `municipalities.${code}`, size);
  }

  static Factory({ container }: interfaces.Context) {
    return (itemId: string) =>
      new MunicipalityDetailViewModel(
        itemId,
        container.get(EnumRepository),
        container.get(LocalizationService),
        container.get(EventBus),
        container.get(NotificationService),
        container.get(SecurityService),
        container.get(OptionsService)
      );
  }
}
